import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import Button from '../Button/Button'
import Calendar from '../../images/icons/calendar-black.svg'
import { formatISO } from 'date-fns'

export const StyledButton = styled(Button)`
  ${({ fullWidth }) => fullWidth && css`width: 100%;`}
`;

const ADD_TO_CALENDAR = 'Add To My Calendar'
const TIMEZONE = 'Europe/Paris'

const CalendarButton = ({ startDate, endDate, fullWidth = false, title, isMobile }) => {

  const [event, setEvent] = useState(null)
  const [isMounted, setIsMounted] = useState(false)

  const formatStartDate = () => {
    const date = new Date(startDate)
    const newStartDate = date.setHours(date.getHours() - 1)
    return formatISO(new Date(newStartDate), { format: 'basic' }).slice(0, -6) + 'Z'
  }

  const formatEndDate = () => {
    if (endDate) {
      const date = new Date(endDate)
      const newEndDate = date.setHours(date.getHours() - 1)
      return formatISO(new Date(newEndDate), { format: 'basic' }).slice(0, -6) + 'Z'
    } else {
      return formatISO(new Date(startDate), { format: 'basic' }).slice(0, -6) + 'Z'
    }
  }

  useEffect(() => {
    setIsMounted(true)
    setEvent({
      title: title,
      startDate: formatStartDate(),
      endDate: formatEndDate(),
    })
  }, [])

  const saveCalInvite = () => {
    // Create the .ics URL
    let url = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'X-WR-TIMEZONE:' + TIMEZONE,
      'BEGIN:VEVENT',
      'DTSTART:' + event.startDate,
      'DTEND:' + event.endDate,
      'SUMMARY:' + event.title,
      'BEGIN:VALARM',
      'TRIGGER:-PT15M',
      'REPEAT:1',
      'DURATION:PT15M',
      'ACTION:DISPLAY',
      'DESCRIPTION:Reminder',
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n')

    return encodeURI('data:text/calendar;charset=utf8,' + url)
  }

  return isMounted ? (
    <StyledButton
      iconOnly={isMobile}
      href={saveCalInvite()}
      variant={ButtonVariantEnum.secondary}
      $fullWidth={fullWidth}
      download={`${event.title}.ics`}
    >
      {!isMobile && ADD_TO_CALENDAR}
      <Calendar />
    </StyledButton>
  ) : null
}

export default CalendarButton
